import { Dialog, Stack, styled } from "@mui/material";
import { CloseIcon, GmailGreen, UserPlusIcon } from "Assets/icons";
import TextButton from "./TextButton";
// import ContactUnlockPopup from "components/popup/ContactUnlockPopup";
import { useState } from "react";
import { ChatUserDetailType } from "types/chat";
import { useLoading } from "providers/loading";
import { apiPurchaseContact } from "services/api/contact";
import { apiGetUserBalance } from "services/api/user";
import { useDispatch, useSelector } from "react-redux";
import { updateUserContactQuote } from "redux/actions/user";
import useUser from "hooks/useUser";
import ContactUnlockPopup from "Components/popup/ContactUnlockPopup";
import { GreenButton } from "Components/Button";
import { SmTextSemibold, SmText } from "Components/Text";
import { closeDialog } from "redux/actions/dialog";
import { getOpenDialog } from "redux/reducers/dialog";
import { useIntl } from "react-intl";

type Props = {
  userDetail?: ChatUserDetailType;
  onReload?: () => void;
};

const UnlockChatButton = ({ userDetail, onReload }: Props) => {
  const t = useIntl();
  const [showDialog, setShowDialog] = useState(false);
  const { setLoading } = useLoading();
  const dispatch = useDispatch();
  const { userContactQuote, user } = useUser();
  const isOpenDialog = useSelector(getOpenDialog);

  const onCloseDialog = () => {
    setShowDialog(false);
  };

  const onClickGetContact = async () => {
    if (userContactQuote > 0) {
      try {
        setLoading(true);
        await apiPurchaseContact({ contact_id: userDetail?.name }).then((res) => {
          // showNotification(`${t("buyer_contact_sent")}`, true)
        });
        await apiGetUserBalance().then((res) => {
          dispatch(
            updateUserContactQuote(res.data.message?.data?.contact_quota)
          );
        });
        onReload?.();
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
    else {
      setShowDialog(true);
    }
  };

  return (
    <>
      <TextButton
        onClick={onClickGetContact}
        sx={{
          flexDirection: "column",
          fontSize: 12,
          whiteSpace: "nowrap",
        }}
      >
        <UserPlusIcon />
        {t.formatMessage({id:"unlock_chat"})}
      </TextButton>

      {/* <Dialog
        open={showDialog}
        onClose={onCloseDialog}
        PaperProps={{ sx: { width: "100%", maxWidth: 473 } }}
      >
        <ContactUnlockPopup onClose={onCloseDialog} />
      </Dialog>  */}
      <Dialog
        open={showDialog}
        onClose={onCloseDialog}
        PaperProps={{ sx: { width: "100%", maxWidth: 473 } }}
      >
        <ContactUnlockPopup
          {...{ onReload }}
          onClose={onCloseDialog}
          contact_id={userDetail?.name}
          title="use_credits_unlock_chat_card"
        />
      </Dialog>
      <Dialog open={isOpenDialog} onClose={() => dispatch(closeDialog())}>
              <StyleBox>
                <StyleDiv>
                  <div>
                    <GmailGreen />
                    <SmTextSemibold fontSize={16}>{t.formatMessage({ id: "buyer_contact_sent_email" })}</SmTextSemibold>
                  </div>
                  <CloseIcon onClick={() => dispatch(closeDialog())} />
                </StyleDiv>
                <div className="container-text">
                  <SmText fontSize={14} fontWeight={400}>{t.formatMessage({ id: "buyer_contact_detail" }, { email: <span className="text-email">{user?.email}</span> })}</SmText>
                </div>
                <GreenButton onClick={() => dispatch(closeDialog())}>{t.formatMessage({ id: "ok" })}</GreenButton>
              </StyleBox>
            </Dialog>
    </>
  );
};
const StyleDiv = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  ">div": {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
  }
}))
const StyleBox = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  boxShadow: "0px 8px 8px -4px #10182808",
  padding: '24px',
  borderRadius: '12px',
  gap: '8px',
  ".text-email": {
    color: '#026AA2'
  }
}))
export default UnlockChatButton;
